import {Chip} from '@mui/material';
import {STATUS_LABEL_MAP} from './constants';

const StatusChip = ({status}: {status: string}) => {
  const displayStatus = STATUS_LABEL_MAP[status.toLowerCase()] || status;
  return (
    <Chip
      label={<span>{displayStatus}</span>}
      className={`status-chip status-${status.toLowerCase()} w-[120px]`}
      data-testid={`status-chip-${status.toLowerCase()}`}
    />
  );
};

export default StatusChip;
